import { h } from '../dom';
import { api, type Relation, type User } from '../../api/client';
import { avatar, confirmBox, empty, guard, section, skeleton } from '../components';
import { postCard } from '../post';
import { shell } from '../shell';
import { navigate } from '../router';

export function renderProfile(root: HTMLElement, me: User, id: string) {
  if (id === me.id) return navigate('#/me', true);
  const content = shell(root, { title: 'Trang cá nhân', back: '#/friends' });
  content.append(section(() => api.profile(id), ({ user, relation, streak, sessionsTogether }, reload) => {
    const actions = h('div.ph-actions');
    const btn = (label: string, cls: string, fn: () => Promise<unknown>) =>
      h(`button.${cls}`, { onclick: async () => { await fn(); reload(); } }, label);
    const rel: Relation = relation;
    if (rel === 'NONE') actions.append(btn('Kết bạn', 'primary', () => guard(api.sendRequest(id), 'Đã gửi lời mời')));
    if (rel === 'REQUEST_SENT') actions.append(h('span.pill', {}, 'Đã gửi lời mời kết bạn'));
    if (rel === 'REQUEST_RECEIVED') actions.append(h('a.primary.btn', { href: '#/friends?tab=requests' }, 'Trả lời lời mời'));
    if (rel === 'FRIENDS') {
      actions.append(
        h('button.primary', { onclick: () => void inviteToShoot(user) }, '🎞 Rủ chụp'),
        btn('Bạn bè ✓', 'secondary.ghost', async () => {
          if (await confirmBox(`Huỷ kết bạn với ${user.displayName}?`, 'Huỷ kết bạn')) await guard(api.unfriend(id));
        }));
    }
    const more = rel === 'BLOCKED'
      ? btn('Bỏ chặn', 'link', () => guard(api.unblock(id), 'Đã bỏ chặn'))
      : btn('Chặn', 'link.muted', async () => {
        if (await confirmBox(`Chặn ${user.displayName}? Hai bạn sẽ không thấy nhau nữa.`, 'Chặn')) await guard(api.block(id), 'Đã chặn');
      });
    const posts = h('div.feed', {}, skeleton('post', 1));
    if (rel !== 'BLOCKED') void api.userPosts(id).then((list) => posts.replaceChildren(...(list.length
      ? list.map((p) => postCard(p, me, { showCollab: true }))
      : [empty('🖼', rel === 'FRIENDS' ? 'Rủ nhau chụp một dải ảnh đầu tiên nhé!' : 'Kết bạn để xem ảnh của nhau',
        rel === 'FRIENDS' ? h('button.primary', { onclick: () => void inviteToShoot(user) }, '🎞 Rủ chụp') : null,
        'Chưa có bài đăng')]))).catch((e) => posts.replaceChildren(h('p.tiny', {}, (e as Error).message)));
    else posts.replaceChildren();
    return h('div.stack', {},
      profileHeader(user, { streak, sessionsTogether, actions, more }),
      h('h3.sechead', {}, 'Ảnh'),
      posts);
  }, () => h('div', {}, h('div.ph.sk-ph', {}, h('i.sk.sk-circle.huge'), h('i.sk.sk-line.w60'), h('i.sk.sk-line.w30')), skeleton('post', 1))));
}

/** Big avatar, name, @username, bio, stats, actions (also used by Tôi). */
export function profileHeader(user: User, o: {
  streak?: number; sessionsTogether?: number; actions?: HTMLElement; more?: HTMLElement | null; avatarEl?: HTMLElement; stats?: HTMLElement[];
}) {
  const stats = o.stats ?? [
    h('div.stat', {}, h('b', {}, o.streak ? `🔥 ${o.streak}` : '–'), h('small', {}, o.streak ? 'ngày liên tiếp' : 'chưa có chuỗi')),
    h('div.stat', {}, h('b', {}, String(o.sessionsTogether ?? 0)), h('small', {}, 'lần chụp chung')),
  ];
  return h('section.ph', {},
    h('div.ph-cover', { 'aria-hidden': 'true' }),
    o.avatarEl ?? h('div.ph-avatar', {}, avatar(user, 104)),
    h('h2', {}, user.displayName),
    user.username ? h('p.ph-user', {}, `@${user.username}`) : null,
    user.bio ? h('p.ph-bio', {}, user.bio) : null,
    stats.length ? h('div.ph-stats', {}, ...stats) : null,
    o.actions ?? null,
    o.more ?? null);
}

/** One tap: create an instant room, invite this friend, go to the booth. */
export async function inviteToShoot(friend: User) {
  const room = await guard(api.createRoom(`Chụp với ${friend.displayName}`, 'INSTANT'));
  if (!room) return;
  await guard(api.invite(room.id, [friend.id]), `Đã mời ${friend.displayName} – chờ bạn ấy vào nhé`);
  navigate(`#/booth/${room.id}`);
}
